<div class="header-navigation" fxLayoutAlign="left">
  <span>Dashboard</span>
</div>

<div class="dashboard-container" >
  @if (!isProfileContentReady) {
    <div>
      <ngx-skeleton-loader
        appearance="circle"
      [theme]="{
        width: '60px',
        height: '60px'
      }"
        >
      </ngx-skeleton-loader>
      <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
    </div>
  } @else {
    <div class="profile-row" >
      <img [src]="profilePicturePath" class="profile-image" />
      <div class="driver-name">
        Hello,
        <br />
        {{ driverName }}
      </div>
    </div>
  }

  @if (!loading) {
    <mat-tab-group
      animationDuration="0ms"
      mat-align-tabs="center"
      mat-stretch-tabs="true"
      class="tab-list"
      (selectedTabChange)="tabChanged($event)"
      [selectedIndex]="currentTab"
      >
      <mat-tab label="Current month" data-test="current-tab">
        <div class="tab-content" >
          <span class="content-header">Overview</span>
          <div class="sections-container">
            <div class="section section-completed">
              <mat-icon svgIcon="checkbox-circle-line-green"></mat-icon>
              <div >
                <span class="count">{{ dashboardContent?.completed }}</span>
                <span class="status">Completed</span>
              </div>
            </div>
            <div class="section section-upcoming">
              <mat-icon svgIcon="calendar-tick"></mat-icon>
              <div >
                <span class="count">{{ dashboardContent?.upcoming }}</span>
                <span class="status">Upcoming</span>
              </div>
            </div>
            <div class="section section-earned">
              <mat-icon svgIcon="money-dollar-circle-line"></mat-icon>
              <div >
                <span class="count">$ {{ dashboardContent?.earned }}</span>
                <span class="status">Earned</span>
                <span class="goal">Goal: {{ dashboardContent?.target_earned }}</span>
                <div
                  class="progress-bar progress-earned"
                  [attr.data-progress-earned]="dashboardContent?.earnedPercent"
                ></div>
              </div>
            </div>
            <div class="section section-miles">
              <mat-icon svgIcon="pin-distance"></mat-icon>
              <div >
                <span class="count">{{ dashboardContent?.miles }} miles</span>
                <span class="status">Driven</span>
                <span class="goal">Goal: {{ dashboardContent?.target_miles }}</span>
                <div
                  class="progress-bar progress-miles"
                  [attr.data-progress-miles]="dashboardContent?.milesPercent"
                ></div>
              </div>
            </div>
          </div>
          <div  >
            <span class="content-header">Ongoing Shipment</span>
            <div [ngClass]="[getStatusClass(), 'status-tag']">
              {{ shipment?.status | titlecase }}
            </div>
          </div>
          <div class="shipment-details-container">
            <div class="route-section">
              <div class="route-visual">
                <div class="route-point from-point">
                  <mat-icon class="route-icon">radio_button_checked</mat-icon>
                </div>
                <div class="route-line"></div>
                <div class="route-point to-point">
                  <mat-icon class="route-icon">location_on</mat-icon>
                </div>
              </div>
              <div class="route-info">
                <div class="route-location">
                  <span class="location-label">From</span>
                  <div class="location-main">{{ shipment?.origin || '-' }}</div>
                  <div class="location-details">{{ shipment?.pickup?.streetAddress || '-' }}</div>
                  <div class="location-time">{{ shipment?.pickupFormattedDateTime || '-' }}</div>
                </div>
                <div class="route-location">
                  <span class="location-label">To</span>
                  <div class="location-main">{{ shipment?.destination || '-' }}</div>
                  <div class="location-details">{{ shipment?.delivery?.streetAddress || '-' }}</div>
                  <div class="location-time">{{ shipment?.deliveryFormattedDateAndTime || '-' }}</div>
                </div>
              </div>
            </div>
            <div class="shipment-actions">
              <button mat-flat-button class="btn-view-more">
                <mat-icon>visibility</mat-icon>
                View more
              </button>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Past month" data-test="past-tab"> </mat-tab>
    </mat-tab-group>
  }
</div>
